import { Syringe } from 'lucide-react';

const MarqueeOutline = () => {
  const text = "BRINGING DEADLY POTENCY TO THE BLOCKCHAIN... LEGENDARY GEEKERS ONLY. FENTCOIN. NODDING TO +$50M. GRAM FOR GRAM. DARK NET PURITY. BROUGHT TO YOU BY TRANQ ANGELS LLC x FETTY TIME-TRAVELLERS INCORPORATED. I WANT TO FIGHT THE POLICE BUT I'M TOO DAMN TIRED.";
  
  return (
    <div className="fixed inset-0 pointer-events-none select-none z-[99]">
      {/* Top scrolling text */}
      <div className="absolute top-0 left-6 right-6 overflow-hidden h-6 text-red-700">
        <div className="relative flex">
          <div className="animate-marquee-left whitespace-nowrap font-mono py-1">
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
          </div>
          <div className="absolute top-0 animate-marquee-left2 whitespace-nowrap font-mono py-1">
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
          </div>
        </div>
      </div>

      {/* Right scrolling text */}
      <div className="absolute top-6 right-0 bottom-6 w-6 overflow-hidden text-red-700">
        <div className="relative flex flex-col h-full">
          <div className="animate-marquee-down whitespace-nowrap font-mono" style={{ writingMode: 'vertical-rl' }}>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
          </div>
          <div className="absolute top-0 animate-marquee-down2 whitespace-nowrap font-mono" style={{ writingMode: 'vertical-rl' }}>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
          </div>
        </div>
      </div>

      {/* Bottom scrolling text */}
      <div className="absolute bottom-0 left-6 right-6 overflow-hidden h-6 text-red-700">
        <div className="relative flex">
          <div className="animate-marquee-right whitespace-nowrap font-mono py-1">
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
          </div>
          <div className="absolute top-0 animate-marquee-right2 whitespace-nowrap font-mono py-1">
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
            <span className="mr-4">{text}</span>
          </div>
        </div>
      </div>

      {/* Left scrolling text */}
      <div className="absolute top-6 left-0 bottom-6 w-6 overflow-hidden text-red-700">
        <div className="relative flex flex-col h-full">
          <div className="animate-marquee-up whitespace-nowrap font-mono" style={{ writingMode: 'vertical-rl' }}>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
          </div>
          <div className="absolute top-0 animate-marquee-up2 whitespace-nowrap font-mono" style={{ writingMode: 'vertical-rl' }}>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
            <span className="mb-4">{text}</span>
          </div>
        </div>
      </div>

      {/* Corner covers with Syringe icons */}
      <div className="absolute top-0 left-0 w-6 h-6 bg-black flex items-center justify-center">
        <Syringe size={24} className="text-white" />
      </div>
      <div className="absolute top-0 right-0 w-6 h-6 bg-black flex items-center justify-center">
        <Syringe size={24} className="text-white" />
      </div>
      <div className="absolute bottom-0 left-0 w-6 h-6 bg-black flex items-center justify-center">
        <Syringe size={24} className="text-white" />
      </div>
      <div className="absolute bottom-0 right-0 w-6 h-6 bg-black flex items-center justify-center">
        <Syringe size={24} className="text-white" />
      </div>
    </div>
  );
};

export default MarqueeOutline